import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { BalanceList } from '../components/features/BalanceList';

export const BalancePage: React.FC = () => {
  return (
    <AppLayout title="Мой баланс">
      <BalanceList />
    </AppLayout>
  );
};